import { useRef, useEffect } from 'react';

// Devuelve una variable que controla si el renderizado actual es el primero (el de montaje)
export const useIsMount = () => {
  const isMountRef = useRef(true);
  useEffect(() => {
    isMountRef.current = false;
  }, []);
  return isMountRef.current;
};